import React, { useEffect } from "react";
import styled from "styled-components";
import {
  Switch,
  Route,
  useRouteMatch,
  useParams,
  Redirect,
  useLocation,
} from "react-router-dom";
import { Typography } from "@material-ui/core";
import Berita from "./Berita";
import Kegiatan from "./Kegiatan";
import Loker from "./Loker";
import PenawaranTender from "./PenawaranTender";
import PengumumanLainnya from "./PengumumanLainnya";

import Context from "../../context";
import { Banner, CardSubMenu } from "../../components";

const StyledBody = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 40px;
  margin: 0 16px;
  padding-bottom: 32px;
  @media screen and (max-width: 500px) {
    flex-direction: column;
  }
`;

const StyledSidebar = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  @media screen and (max-width: 500px) {
    width: 100%;
  }
`;

const StyledBorder = styled.div`
  border-left: 1px solid #d4d4d4;
  margin: 0 40px;
  @media screen and (max-width: 800px) {
    margin-left: 16px;
    margin-right: 32px;
  }
  @media screen and (max-width: 500px) {
    display: none;
  }
`;

const StyledContent = styled.div`
  width: 100%;
  max-width: 750px;
  flex: 1;
  padding-top: 16px;
  @media screen and (max-width: 500px) {
    padding-top: 32px;
  }
`;

const DataRuangBerita = [
  {
    title: "Berita",
    titleEn: "News",
    subUrl: "/berita",
  },
  {
    title: "Kegiatan",
    titleEn: "Activities",
    subUrl: "/kegiatan",
  },
  {
    title: "Pengumuman",
    titleEn: "Announcement",
    children: [
      {
        title: "Lowongan Pekerjaan",
        titleEn: "Job Vacancy",
        subUrl: "/lowongan-pekerjaan",
      },
      {
        title: "Pengadaan Barang / Jasa",
        titleEn: "Procurement of Goods / Services",
        subUrl: "/pengadaan-barang-jasa",
      },
      {
        title: "Pengumuman Lainnya",
        titleEn: "Other Announcement",
        subUrl: "/pengumuman-lainnya",
      },
    ],
  },
];

const breadcrumbsPengumuman = (text: string) => {
  const arrChildren = DataRuangBerita.find((r) =>
    r.title.includes("Pengumuman")
  )?.children;
  return arrChildren?.find((r) => r.subUrl === `/${text}`);
};

const breadcrumbsLvl2 = (text: string) => {
  let parent = DataRuangBerita.find((r) =>
    r.title.toLowerCase().includes(text)
  );
  if (!parent) {
    parent = breadcrumbsPengumuman(text);
  }
  return parent;
};

const RuangBeritaSub = ({ isId }: { isId: boolean }) => {
  const { ruangBeritaId }: any = useParams();

  if (ruangBeritaId === "berita") return <Berita isId={isId} />;
  if (ruangBeritaId === "kegiatan") return <Kegiatan isId={isId} />;
  if (ruangBeritaId === "lowongan-pekerjaan") return <Loker isId={isId} />;
  if (ruangBeritaId === "pengadaan-barang-jasa")
    return <PenawaranTender isId={isId} />;
  if (ruangBeritaId === "pengumuman-lainnya")
    return <PengumumanLainnya isId={isId} />;
  return <>Not Found</>;
};

const RuangBerita = () => {
  const { path, url } = useRouteMatch();
  const { pathname, state }: any = useLocation();
  const context = React.useContext(Context);
  const currentLang = context.getLang();
  const isId = currentLang === "ID";
  const valBreadcrumbsLvl2 = pathname.split("/")[2];
  const valBreadcrumbsLvl3 = pathname.split("/")[3];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Banner title={isId ? "Ruang Berita" : "News Room"} />
      <div style={{ marginTop: "3rem", padding: "0 16px" }}>
        <Typography
          style={{
            margin: "0 auto",
            maxWidth: 1130,
          }}
        >
          {isId ? "Ruang Berita" : "News Room"}
          &nbsp; &gt; &nbsp;{" "}
          {breadcrumbsLvl2(valBreadcrumbsLvl2)?.title.includes(" ") &&
            (isId ? (
              <span>Pengumuman &nbsp; &gt; &nbsp;</span>
            ) : (
              <span>Announcements &nbsp; &gt; &nbsp;</span>
            ))}
          <span style={{ color: valBreadcrumbsLvl3 ? "#000" : "#e3232a" }}>
            {isId
              ? breadcrumbsLvl2(valBreadcrumbsLvl2)?.title
              : breadcrumbsLvl2(valBreadcrumbsLvl2)?.titleEn}
          </span>
          {valBreadcrumbsLvl3 && (
            <>
              &nbsp; &gt; &nbsp;{" "}
              <span style={{ color: "#e3232a" }}>
                {isId ? state.title_id : state.title_en}
              </span>
            </>
          )}
        </Typography>
      </div>
      <StyledBody>
        <StyledSidebar>
          <CardSubMenu
            title={isId ? "Ruang Berita" : "News Room"}
            url={url}
            isId={isId}
            data={DataRuangBerita}
          />
        </StyledSidebar>
        <StyledBorder />
        <StyledContent>
          <Switch>
            <Route exact path={path}>
              <Redirect to={`${path}/berita`} />
            </Route>
            <Route path={`${path}/:ruangBeritaId`}>
              <RuangBeritaSub isId={isId} />
            </Route>
          </Switch>
        </StyledContent>
      </StyledBody>
    </>
  );
};

export default RuangBerita;
